import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex);

import userInfoStore from './userInfo/userInfo';
import aiStore from './ai/aiStore';
import repoStore from './repo/repo';
import calendarStore from './calendar/calendarStore';
import chatStore from './chat/chat'
import {objectifyArr} from "@/codeFunctions";
import {dbGlobalMethods, dbMethods} from "@/localDBFunction";

const store = new Vuex.Store({
    modules: {ai: aiStore, userInfo: userInfoStore, repo: repoStore, cal: calendarStore, chat: chatStore},
    state() {
        return {
            themePref: 'auto',
            darkTheme: false,
            placeholder: false,
            localData: null,
            getTaskHeaderFn: null,
            loggedIn: false,
            oPlugIgnore: false,
            showChat: false,
            curView: null,
            typeCatalogSet: new Set(["3g2", "3ga", "3gp", "7z", "aa", "aac", "ac", "accdb", "accdt", "adn", "ai", "aif", "aifc", "aiff", "ait", "amr", "ani", "apk", "app", "applescript", "asax", "asc", "ascx", "asf", "ash", "ashx", "asmx", "asp", "aspx", "asx", "au", "aup", "avi", "axd", "aze", "bak", "bash", "bat", "bin", "blank", "bmp", "bowerrc", "bpg", "browser", "bz2", "c", "cab", "cad", "caf", "cal", "cd", "cer", "cfg", "cfm", "cfml", "cgi", "class", "cmd", "codekit", "coffee", "coffeelintignore", "com", "compile", "conf", "config", "cpp", "cptx", "cr2", "crdownload", "crt", "crypt", "cs", "csh", "cson", "csproj", "css", "csv", "cue", "dat", "db", "dbf", "deb", "dgn", "dist", "diz", "dll", "dmg", "dng", "doc", "docb", "docm", "docx", "dot", "dotm", "dotx", "download", "dpj", "ds_store", "dtd", "dwg", "dxf", "editorconfig", "el", "enc", "eot", "eps", "epub", "eslintignore", "exe", "f4v", "fax", "fb2", "fla", "flac", "flv", "folder", "gadget", "gdp", "gem", "gif", "gitattributes", "gitignore", "go", "gpg", "gz", "h", "handlebars", "hbs", "heic", "hs", "hsl", "htm", "html", "ibooks", "icns", "ico", "ics", "idx", "iff", "ifo", "image", "img", "in", "indd", "inf", "ini", "iso", "j2", "jar", "java", "jpe", "jpeg", "jpg", "js", "json", "jsp", "jsx", "key", "kf8", "kmk", "ksh", "kup", "less", "lex", "licx", "lisp", "lit", "lnk", "lock", "log", "lua", "m", "m2v", "m3u", "m3u8", "m4", "m4a", "m4r", "m4v", "map", "master", "mc", "md", "mdb", "mdf", "me", "mi", "mid", "midi", "mk", "mkv", "mm", "mo", "mobi", "mod", "mov", "mp2", "mp3", "mp4", "mpa", "mpd", "mpe", "mpeg", "mpg", "mpga", "mpp", "mpt", "msi", "msu", "nef", "nes", "nfo", "nix", "npmignore", "odb", "ods", "odt", "ogg", "ogv", "ost", "otf", "ott", "ova", "ovf", "p12", "p7b", "pages", "part", "pcd", "pdb", "pdf", "pem", "pfx", "pgp", "ph", "phar", "php", "pkg", "pl", "plist", "pm", "png", "po", "pom", "pot", "potx", "pps", "ppsx", "ppt", "pptm", "pptx", "prop", "ps", "ps1", "psd", "psp", "pst", "pub", "py", "pyc", "qt", "ra", "ram", "rar", "raw", "rb", "rdf", "resx", "retry", "rm", "rom", "rpm", "rsa", "rss", "rtf", "ru", "rub", "sass", "scss", "sdf", "sed", "sh", "sitemap", "skin", "sldm", "sldx", "sln", "sol", "sql", "sqlite", "step", "stl", "svg", "swd", "swf", "swift", "sys", "tar", "tcsh", "tex", "tfignore", "tga", "tgz", "tif", "tiff", "tmp", "torrent", "ts", "tsv", "ttf", "twig", "txt", "udf", "vb", "vbproj", "vbs", "vcd", "vcs", "vdi", "vdx", "vmdk", "vob", "vscodeignore", "vsd", "vss", "vst", "vsx", "vtx", "war", "wav", "wbk", "webinfo", "webm", "webp", "wma", "wmf", "wmv", "woff", "woff2", "wps", "wsf", "xaml", "xcf", "xlm", "xls", "xlsm", "xlsx", "xlt", "xltm", "xltx", "xml", "xpi", "xps", "xrb", "xsd", "xsl", "xspf", "xz", "yaml", "yml", "z", "zip", "zsh"]),
            pdfFailoverURIString: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(`<?xml version="1.0" encoding="UTF-8"?><svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 4133.63 4851.63"><path d="M3783.13,1316.87v2943.42c0,111.35-90.27,201.62-201.62,201.62H814.05c-111.35,0-201.62-90.27-201.62-201.62V591.35c0-111.35,90.27-201.62,201.62-201.62h2048.05l921.02,927.14Z" style="fill: #ebebeb; stroke-width: 0px;"/><path d="M3783.13,1316.87h-723.11c-109.31,0-197.91-88.61-197.91-197.91V389.73l921.02,927.14Z" style="fill: #ccc; stroke-width: 0px;"/><path d="M612.43,1108.11v1.04c-146.7,12.33-261.93,135.29-261.93,285.19v867.89h261.93v-285.18h1938.94c43.72,0,79.16-35.44,79.16-79.16v-710.61c0-43.72-35.44-79.16-79.16-79.16H612.43Z" style="fill: #f43737; stroke-width: 0px;"/><path d="M612.43,1977.04c-146.7,12.33-261.93,135.29-261.93,285.19s115.23,272.85,261.93,285.19v-570.37Z" style="fill: #c42626; stroke-width: 0px;"/><g><path d="M930.26,1275.29h205.6c106.35,0,184.76,57.86,184.76,159.74,0,110.96-81.89,165.48-190.33,165.48h-101.31v209.35h-98.72v-534.57ZM1028.98,1521.37h92.55c60.72,0,99.01-24.3,99.01-84.32s-41.01-82.48-96.48-82.48h-95.08v166.8h0Z" style="fill: #fff; stroke-width: 0px;"/><path d="M1408.71,1275.29h195.93c153.68,0,252.33,99.56,252.33,258.81s-96.44,275.77-257.09,275.77h-191.16v-534.57ZM1507.43,1730.16h88.71c107.55,0,158.77-78.47,158.77-194.94,0-99.78-49.36-179.77-158.13-179.77h-89.35v374.71h0Z" style="fill: #fff; stroke-width: 0px;"/><path d="M1958.85,1275.29h351.22v81.78h-254.7v146.62h238.81v81.34h-238.81v224.83h-96.52v-534.57Z" style="fill: #fff; stroke-width: 0px;"/></g><path d="M3185.5,2615.82h-1975.45c-47.63,0-86.24,38.61-86.24,86.24h0c0,47.63,38.61,86.24,86.24,86.24h1975.45c47.63,0,86.24-38.61,86.24-86.24h0c0-47.63-38.61-86.24-86.24-86.24Z" style="fill: #ccc; stroke-width: 0px;"/><path d="M3185.5,3154.82h-1975.45c-47.63,0-86.24,38.61-86.24,86.24h0c0,47.63,38.61,86.24,86.24,86.24h1975.45c47.63,0,86.24-38.61,86.24-86.24h0c0-47.63-38.61-86.24-86.24-86.24Z" style="fill: #ccc; stroke-width: 0px;"/><path d="M3185.5,3693.82h-1975.45c-47.63,0-86.24,38.61-86.24,86.24h0c0,47.63,38.61,86.24,86.24,86.24h1975.45c47.63,0,86.24-38.61,86.24-86.24h0c0-47.63-38.61-86.24-86.24-86.24Z" style="fill: #ccc; stroke-width: 0px;"/></svg>`),
            autoLogin: true,
            datasetUpdaterMap: {
                datasetId: null,
                findMap: {id: null, column: null},
                updateMap: [{id: null, column: null}]
            }
        }
    },
    mutations: {
        setLocalData(state, payload) {
            state.localData = payload.value
        },
        setGetTaskHeaderFn(state, payload) {
            state.getTaskHeaderFn = payload
        },
        loggedIn(state, payload) {
            state.loggedIn = payload
        },
        async setTheme(state, payload) {
            await dbGlobalMethods.addConfigValue('theme', payload)
            state.themePref = payload

            if (payload === 'auto')
                state.darkTheme = false // TODO UPDATE THIS WHEN READY !!window.matchMedia("(prefers-color-scheme: dark)").matches
            else
                state.darkTheme = payload === 'dark'
        }
    },
    actions: {
        setLocalData(context, payload) {
            context.commit('setLocalData', {value: payload})
        },
        setGetTaskHeaderFn(context, payload) {
            context.commit('setGetTaskHeaderFn', payload)
        },
        setLoggedIn(context, payload) {
            context.commit('loggedIn', payload)
        },
        setTheme(context, payload) {
            context.commit('setTheme', payload)
        }
    },
    getters: {

        usersWithLinkedContactsSet(state) {
            return new Set((state.localData?.users || []).map(u => u.fkContact).filter(v => !!v))
        },

        loggedIn(state) {
            return state.loggedIn
        },
        getTaskHeader(state) {
            return state.getTaskHeaderFn
        },
        localData(state) {
            return state.localData;
        },
        users(state) {
            class User {
                constructor(obj) {
                    Object.assign(this, obj)
                }
                get fullName() {
                    return `${this.name} ${this.surname}`.trim();
                }
                get initials() {
                    return this.fullName.split(' ').map(str => {return str.substr(0,1)}).join('')
                }
            }
            try {
                return state.localData.users.map(user => {return new User(user)})
            } catch (e) {
                return []
            }
        },
        usersRef(state, getters) {
            return objectifyArr(getters.users, 'userID')
        },

        foldersRef(state) {
            try {
                return objectifyArr(state.localData.folders, 'id')
            } catch (e) {
                return null
            }
        },

        userGroups(state, getters) {
            class UserGroup {
                constructor(obj) {
                    Object.assign(this, obj)
                }
                get usersVal() {
                    return (this.users || [])
                        .map(userID => {
                            return getters.usersRef[userID]
                        })
                }
                get memberNames() {
                    return this.usersVal.map(user => {return user.fullName})
                }
            }
            try {
                return state.localData.userGroups.map(userGroup => {return new UserGroup(userGroup)})
            } catch (e) {
                return []
            }
        },
        userGroupsRef(state, getters) {
            return objectifyArr(getters.userGroups, 'id')
        },

        usersAndGroups(state, getters) {
            return getters.userGroups
                .map((obj) => {
                    return {
                        type: 'group',
                        description: obj.description,
                        icon: "people",
                        color: "light-blue",
                        id: obj.id,
                        refID: `g-${obj.id}`,
                        disabled: false,
                        ref: obj
                    }
                })
                .concat(getters.users.map((obj => {
                    return {
                        type: 'user',
                        description: obj.fullName || obj.username,
                        icon: "person",
                        color: obj.disabled ? 'grey' : 'cyan',
                        id: obj.userID,
                        refID: `u-${obj.userID}`,
                        ref: obj
                    }
                })))
                .sort((a, b) => a.description > b.description ? 1 : -1)
        }
    },
});

export default store


